module.exports = __webpack_public_path__ + "static/media/club_icon_grey.d0cf1658.svg";